import { useEffect, useSyncExternalStore } from 'react';
import { getFeatureFlagSnapshot, subscribeToFeatureFlags } from '@/lib';

export function useFeatureFlag(flagName: string) {
  const snapshot = useSyncExternalStore(subscribeToFeatureFlags, () =>
    getFeatureFlagSnapshot(flagName)
  );

  useEffect(() => {
    console.log(`[useFeatureFlag] ${flagName}:`, snapshot);
  }, [flagName, snapshot]);

  return snapshot;
}
